import {EuiThemeAmsterdam} from "@elastic/eui";

export const ElasticThemeBase = {
    ...EuiThemeAmsterdam
}